import React, { Component, Fragment} from 'react'
import styled from 'styled-components'
import LoadingBar from '../common/LoadingBar'
import UploadDocuments from './queries/UploadDocuments'
import DocumentsQuery from './queries/DocumentsQuery'
import { graphql, compose, withApollo } from 'react-apollo'
import WithLoan from '../shared/WithLoan'

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border: 1px solid transparent;
  margin-bottom: 10px;
  ${props => props.border ? 'border: 1px solid #75AFB6;' : ''}
  border-radius: 3px;
  &:hover {
    border: 1px solid #75AFB6;
    border-radius: 3px;
  }
`
const LoadingBarConteiner = styled.div`
  padding: 20px 0;
  ${props => props.show ? '' : 'display: none'}
`

const UploadLink = styled.a`
  color: #75AFB6;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: none;
    color: #75AFB6;
  }
`
const FileInput = styled.input`
  display: none;
`

class UploadContainer extends Component {
  constructor(props){
    super(props)
    this.state = {
      isUploading: false,
      isUploadDraggedOver: false
    }
  }
  _generalStatus = () => {
    const {reference } = this.props
    return reference ? reference.status : null
  }
  renderFileInput = (reference, key) => {
    return (
      <FileInput
        onChange={e => this.onFileChange(e, reference)}
        innerRef={node => this[`fileInput${key}`] = node}
        type="file"
        multiple
        id={`upload_file_input-${key}`}
      />
    )
  }
  onDragEnter = () => {
    this.setState({ isUploadDraggedOver: true })
  }
  onDragLeave = () => {
    this.setState({ isUploadDraggedOver: false })
  }
  onUploadClick = key => {
    this[`fileInput${key}`].click()
  }
  updateStore = (data, documentData, store) => {
    const { entityId, loanId, resourceType, guarantors, document } = this.props
    const { rid } = document
    let entity
    if (resourceType === 'Business') {
      entity = data.loan.businesses.find(b => b.rid === entityId)
    } else if (resourceType === 'Guarantor') {
      const businessId = guarantors.find(g => g.rid === entityId).business.rid
      const business = data.loan.businesses.find(b => b.rid === businessId)
      entity = business.guarantors.find(g => g.rid === entityId)
    }
    const idx = entity.documents.findIndex(d => d.rid === rid)
    entity.documents[idx] = documentData
    store.writeQuery({ query: DocumentsQuery, variables: { rid: loanId }, data })
  }
  onFileChange = async (e, reference) => {
    const generalStatus = this._generalStatus()
    const { uploadDocuments, loanId, flashSuccessNotification } = this.props
    const { rid } = this.props.document
    const { files } = e.target
    let referenceDate = null
    if (reference) {
      referenceDate = reference.date
    }
    e.preventDefault()
    e.persist()
    this.setState({ isUploading: true })
    try {
      await uploadDocuments({
        variables: {
          input: {
            documentId: rid,
            referenceDate,
            files,
            fileStatus: generalStatus,
            sync: true
          }
        },
        update: (store, { data: { uploadDocuments: { document } } }) => {
          const data = store.readQuery({ query: DocumentsQuery, variables: { rid: loanId } })
          this.updateStore(data, document, store)
        }
      });
      e.target.value = null // Reset file input
      this.setState({ isUploading: false })
      flashSuccessNotification()
    } catch (err) {
      console.log(err)
    }
  }
  onDrop = async (e, reference) => {
    const generalStatus = this._generalStatus()
    const { uploadDocuments, loanId, flashSuccessNotification, document } = this.props
    const { rid } = document
    this.onDragLeave()
    let referenceDate = null
    if (reference) {
      referenceDate = reference.date
    }
    e.preventDefault()
    e.persist()
    this.setState({ isUploading: true })
    try {
      await uploadDocuments({
        variables: {
          input: {
            documentId: rid,
            files: e.dataTransfer.files,
            referenceDate,
            fileStatus: generalStatus,
            sync: true
          }
        },
        update: (store, { data: { uploadDocuments: { document } } }) => {
          const data = store.readQuery({ query: DocumentsQuery, variables: { rid: loanId } })
          this.updateStore(data, document, store)
        }
      })
      this.setState({ isUploading: false })
      flashSuccessNotification()
    } catch (err) {
      console.log(err)
    }
  }
  render() {
    const { reference, referenceKey } = this.props
    const { isUploading, isUploadDraggedOver } = this.state

    if (this.props.document.type == "Document::Miscellaneous") {
      return null
    }
    return (
      <Fragment>
        <LoadingBarConteiner show={isUploading}>
          <LoadingBar barId={`document_upload_loading_bar_${referenceKey}`} visible={isUploading} />
        </LoadingBarConteiner>
        {!isUploading &&
          (
            <Container
              border={isUploadDraggedOver}
              onClick={() => this.onUploadClick(referenceKey)}
              onDrop={e => this.onDrop(e, reference)}
              onDragOver={this.onDragEnter}
              onDragLeave={this.onDragLeave}
              id={`upload_document_${referenceKey}`}
            >
              <UploadLink>
                Upload Document
              </UploadLink>
              {this.renderFileInput(reference, referenceKey)}
            </Container>
          )
        }
      </Fragment>
    )
  }
}

export default compose(
  graphql(UploadDocuments, {
    name: 'uploadDocuments'
  }),
  WithLoan,
  withApollo
)(UploadContainer)
